const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.wishlist-product-card',
};

document.addEventListener('DOMContentLoaded', () => {
  initButtons();
  initGrid();
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  var itemsArray = event.detail.wishlist;
  if(itemsArray.length > 0){
    document.getElementById("wishlist-header").classList.add(BUTTON_ACTIVE_CLASS);
  } else {
    document.getElementById("wishlist-header").classList.remove(BUTTON_ACTIVE_CLASS); 
  }
  console.log('[Shopify Wishlist] Wishlist Updated', event.detail.wishlist,itemsArray.length);
  initGrid();

  if(itemsArray.length==0){
    if(document.getElementById('empty_wishlist')){
      document.getElementById('empty_wishlist').style.display = "block";
    }
    
  }
  
  document.getElementById("wishlist-header").classList.add('wishlist-animate');
  setTimeout(function(){
   document.getElementById("wishlist-header").classList.remove('wishlist-animate');
  },200); 
  
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  var itemsArray = event.detail.wishlist;
  if(itemsArray.length > 0){
    document.getElementById("wishlist-header").classList.add(BUTTON_ACTIVE_CLASS);
    $.getScript('https://cdn.shopify.com/s/files/1/1235/7388/t/141/assets/product-form.js',function() {});
    document.getElementById("wishlist-cart-heading").classList.add(BUTTON_ACTIVE_CLASS);
  } else {
    document.getElementById("wishlist-header").classList.remove(BUTTON_ACTIVE_CLASS);
    document.getElementById("wishlist-cart-heading").classList.remove(BUTTON_ACTIVE_CLASS);
    document.getElementById("wishlist-saved-items").innerHTML = '<h6 class="orange-clr my-2">Your wishlist is empty.</h6>';
  }
  //console.log('[Shopify Wishlist] Wishlist Product List Loaded', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  console.log('[Shopify Wishlist] Wishlist Buttons Loaded', event.detail.wishlist);
  var itemsArray = event.detail.wishlist;
  if(itemsArray.length > 0){
    document.getElementById("wishlist-header").classList.add(BUTTON_ACTIVE_CLASS);
  } else {
    document.getElementById("wishlist-header").classList.remove(BUTTON_ACTIVE_CLASS); 
  }
});

const fetchProductCardHTML = (handle) => {
  var productTileTemplateUrl = `/products/${handle}?view=wishlist`;
  if(document.body.classList.contains('your-shopping-cart-page-body')){
     productTileTemplateUrl = `/products/${handle}?view=wishlist-cart`;
  } else {
     productTileTemplateUrl = `/products/${handle}?view=wishlist`;
  }
  
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    button.addEventListener('click', () => {
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  var timer;
  $('[button-wishlist]').each(function(){
   $(this).on('click',function(){
     if($(this).hasClass('active') == false){
       $('#wishlistBottomNotificationBar').prop('checked',true);
     }
     if($(this).hasClass('active') == true){
       $('#wishlistBottomNotificationBar').prop('checked',false);
       clearTimeout(timer);
     } else {
     timer = setTimeout(function(){
         console.log('false1');  
         $('#wishlistBottomNotificationBar').prop('checked',false); 
      },2000);
    }
   });
  });
  
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if(wishlist!=false){
    if(document.getElementById('empty_wishlist')){
      document.getElementById('empty_wishlist').style.display = "none";
    }
    
  }
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};